import { of } from 'rxjs'
import { ViewableIssue } from 'src/app/account/components/issues-view/issues-view.component'
import { BaseIssue, RaisedIssueScope } from 'src/app/account/services/issue'
import { ResourceType } from 'src/utils/resource-types'
import { Arn } from 'src/utils/types'

let issueCounter = 0

// Issue ids are sequential per scenario, so every builder restarts the counter.
export function resetIssueCounter(): void {
  issueCounter = 0
}

export function vi(
  issue: BaseIssue,
  resourceType: ResourceType,
  scope: RaisedIssueScope,
  resourceName: string = 'Resource Name',
  // Override the derived ARN. Needed for the duplicate-scenario case where two
  // distinct resources (different ARNs) share an identical display name.
  arnOverride?: string
): ViewableIssue {
  issueCounter++
  return {
    arn: (arnOverride ??
      `arn:aws:MOCK-TEST:us-east-1:123456789012:${resourceType}/${resourceName.replace(/\s/g, '-').toLowerCase()}`) as Arn,
    issue,
    issueId: `MOCK-TEST-issue-${issueCounter}`,
    resourceName,
    resourceType,
    resourceVariant: null,
    scope,
    issueDto: null,
    deleter$: () => of(null),
    timestamp: new Date(),
  } as ViewableIssue
}
